/** @format */

import {useSearchParams} from 'react-router-dom';
import {add, endOfDay, isValid, parseISO} from 'date-fns';

import {Period} from 'components/PeriodSelector/model';

interface DateFromUrlParams {
  startDate: Date;
  endDate: Date;
  period: Period;
}

export const useDateFromUrlParams = (): DateFromUrlParams => {
  const now = new Date();
  const [searchParams] = useSearchParams();

  const urlStartDate = searchParams.get('startDate');
  const urlEndDate = searchParams.get('endDate');

  let parsedStartDate;
  let parsedEndDate;

  if (urlStartDate) {
    const parsed = parseISO(urlStartDate);
    if (isValid(parsed)) {
      parsedStartDate = parsed;
    }
  }

  if (urlEndDate) {
    const parsed = parseISO(urlEndDate);
    if (isValid(parsed)) {
      parsedEndDate = parsed;
    }
  }

  if (parsedStartDate && parsedEndDate) {
    return {
      startDate: parsedStartDate,
      endDate: endOfDay(parsedEndDate),
      period: 'custom',
    };
  }

  return {
    startDate: add(now, {days: -7}),
    endDate: now,
    period: 'week',
  };
};
